import queryString from 'query-string';
import { requestFacetedItems, clearCustomPriceRange, showMobileFacets, hideMobileFacets } from '../actions/facetActions';

import { getCurrentCategory, getQSWithoutFacetType,
    getCleanSearchQueryString, onCategoryPopstate } from '../utils/utils';

import template from 'facets/category-facets-mobile.j2';
import { mDom } from '../../../core/js/utils/renderUtils';
import { generate } from '../../../core/js/utils/componentUtils';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import { bindOnPopStateEvent } from '../../../core/js/utils/browserUtils';
import { synchronizeWithMobileFacetState, DONE_BUTTON_CLICKED } from '../utils/mobileFacetUtils';

/**
 * Attach component events to DOM
 * @param {object} store - The store
 * @returns {undefined}
 */
export function attachEvents(store) {
    this.store = store;
    bindOnPopStateEvent(this, onCategoryPopstate);

    $(document).on(`touchend.${this.templateLocation} click.${this.templateLocation}`, '.js-facets-reset', (e) => {
        e.preventDefault();
        if (!store.getState().category.queryString) {
            return false;
        }
        this.attachLoader(store);
        const categoryId = getCurrentCategory();

        store.dispatch(clearCustomPriceRange());
        store.dispatch(requestFacetedItems(categoryId, '', '', false, getCleanSearchQueryString(), true, e, this));
        return true;
    });

    $(document).on(`touchend.${this.templateLocation} click.${this.templateLocation}`,
    '.js-clear-custom-price-facet', (e) => {
        store.dispatch(clearCustomPriceRange());
    });

    $(document).on(`touchend.${this.templateLocation} click.${this.templateLocation}`, '.js-mobile-filter', (e) => {
        $(e.target).blur();
        e.preventDefault();
        e.stopPropagation();
        this.removeLoader(store);
        store.dispatch(showMobileFacets());
    });

    $(document).on(`touchend.${this.templateLocation} click.${this.templateLocation}`,
    this.scopedSelector('.js-mobile-filter-close'), (e) => {
        e.preventDefault();
        store.dispatch(hideMobileFacets());
    });

    $(document).on(`touchend.${this.templateLocation} click.${this.templateLocation}`,
    '.js-mobile-filter-clear', (e) => {
        e.preventDefault();
        this.attachLoader(store);
        const el = $(e.currentTarget);
        const qs = el.attr('data-applied-facets-query');
        const qsWithoutFacetType = getQSWithoutFacetType(qs, el.attr('data-facet-type').trim());
        const categoryId = getCurrentCategory();

        store.dispatch(requestFacetedItems(categoryId, '', '', false, queryString.stringify(qsWithoutFacetType),
                       true, e, this));
    });

    $(document).on('RECEIVED_CATEGORY_ITEMS', (e) => {
        this.removeLoader(store);

        if (_.get(e, 'payload.context') === DONE_BUTTON_CLICKED) {
            store.dispatch(hideMobileFacets());
        }
    });
}

export function onStateChange(store) {
    this.render(store, this, {});
}

function beforeRender(store) {
    const mobileFacetState = _.get(store.getState(), 'category.mobileFacetState', {});
    synchronizeWithMobileFacetState(mobileFacetState);
}

export function afterRender(store) {
    if (!_.isEmpty(this.loader)) {
        this.attachLoader(store);
    }
}

/**
 * Bootstrap the component onto the page
 * @param {object} store - The store
 * @param {object} overrides - The overrides object
 * @returns {undefined}
 */
export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-mobile-facets',
        watch: ['category.queryString', 'category.mobileFacetState'],
        name: 'mobileFacetComponent',
        bodyClass: 'has-modal-open',
        attachEvents: attachEvents,
        onStateChange: onStateChange,
        template: template,
        beforeRender: beforeRender,
        afterRender: afterRender,
        renderType: mDom
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
